var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRistrutturazioneBagni(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    id: "svg4",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#09253e",
    stroke: "#09253e",
    strokeMiterlimit: 10,
    d: "M5,22.5V33.12H8.12S9.37,33,9.37,31.88V23.12c0-1.12-1.25-1.24-1.25-1.24H5Z",
    id: "path1",
    style: {
      stroke: "#09253e",
      strokeOpacity: 1,
      fill: "none",
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2",
    style: {
      fill: "none",
      stroke: "#09253e",
      strokeOpacity: 1,
      strokeWidth: 1,
      strokeDasharray: "none"
    },
    d: "M 17.5 20.400391 L 17.5 22.5 A 3.58 3.58 0 0 1 15 25 L 9.3691406 25 L 9.3691406 30.619141 L 13.119141 30.619141 C 13.119141 30.619141 13 33 20 35 A 11.4 11.4 0 0 0 25 35 C 31 33 31 31 31 31 L 38 31 A 1 1 0 0 1 39 32 L 39 35 L 45 35 L 45 30 C 45 25 40 25 40 25 L 29.369141 25 A 3.58 3.58 0 0 1 26.869141 22.5 L 26.869141 20.400391 L 17.5 20.400391 z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3",
    d: "M 22.111328 7 C 21.594624 7.0026636 21.182168 7.5320319 21.185547 8.1875 L 21.189453 9.0253906 L 17.035156 9.0253906 C 16.379679 9.0253906 15.853516 9.4403198 15.853516 9.9570312 L 15.853516 10.033203 C 15.853516 10.549915 16.379679 10.964844 17.035156 10.964844 L 21.199219 10.964844 L 21.210938 13.119141 L 19.685547 13.119141 C 19.685547 13.119141 18.435547 13.499141 18.435547 14.369141 L 18.435547 16.400391 L 25.935547 16.400391 L 25.935547 14.369141 C 25.935547 13.499141 24.685547 13.119141 24.685547 13.119141 L 23.150391 13.119141 L 23.138672 10.964844 L 27.333984 10.964844 C 27.989461 10.964844 28.517578 10.549915 28.517578 10.033203 L 28.517578 9.9570312 C 28.517578 9.4403198 27.989461 9.0253906 27.333984 9.0253906 L 23.128906 9.0253906 L 23.125 8.1777344 C 23.121621 7.5222663 22.702251 6.9973364 22.185547 7 L 22.111328 7 z ",
    style: {
      stroke: "#09253e",
      strokeOpacity: 1,
      fill: "none",
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#09253e",
    stroke: "#09253e",
    strokeMiterlimit: 10,
    x: 15.685,
    y: 16.4,
    width: 13,
    height: 4,
    id: "rect3",
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#09253e",
    strokeMiterlimit: 10,
    d: "M43.87,40.49,42,38l-1.87,2.49a4.42,4.42,0,0,0-.23,5.12,2.19,2.19,0,0,0,.36.39,2.56,2.56,0,0,0,3.48,0,2.19,2.19,0,0,0,.36-.39A4.42,4.42,0,0,0,43.87,40.49Z",
    id: "path4",
    style: {
      strokeWidth: 1,
      strokeDasharray: "none"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRistrutturazioneBagni);
export default __webpack_public_path__ + "static/media/ristrutturazione_bagni.0fb5d8347bc7159f48405195cbe055a9.svg";
export { ForwardRef as ReactComponent };